import React from 'react';
import Team, { teamMembers } from '../components/Team';
import Seo from '../components/Seo';

const SITE_URL = 'https://bocadelraypath.com';

// schema.org's MedicalSpecialty enumeration doesn't have entries for our
// display-facing specialty labels — map to the closest valid enum member
// (https://schema.org/MedicalSpecialty) rather than sending free text,
// which the Schema Markup Validator flags as an invalid value.
const SCHEMA_MEDICAL_SPECIALTY = {
  'GI Pathology': 'Gastroenterologic',
  Hematopathology: 'Hematologic'
};

const physicianSchema = teamMembers.map((member) => ({
  '@context': 'https://schema.org',
  '@type': ['Person', 'Physician'],
  name: member.name,
  identifier: {
    '@type': 'PropertyValue',
    propertyID: 'NPI',
    value: member.npi
  },
  sameAs: [`https://npiregistry.cms.hhs.gov/provider-view/${member.npi}`, ...(member.profiles || [])],
  medicalSpecialty: member.specialties.map((s) => SCHEMA_MEDICAL_SPECIALTY[s] || s),
  worksFor: {
    '@id': `${SITE_URL}/#organization`
  },
  alumniOf: {
    '@type': 'CollegeOrUniversity',
    name: member.education.school
  },
  image: `${SITE_URL}${member.photo}`
}));

function TeamPage() {
  return (
    <div className="team-page">
      <Seo
        title="Our GI & Anatomic Pathologists"
        path="/team"
        description="Board-certified GI and anatomic pathologists Albert Cohen, Robert Aportela, George Varsegi, John Fortune and Daniel Scharifker, serving Florida clinicians."
        jsonLd={physicianSchema}
      />
      <section className="page-banner">
        <p className="section-label">Meet the Pathologists</p>
        <h1>Our Team</h1>
        <p>Board-certified pathologists serving clinicians across Florida.</p>
      </section>
      <Team />
    </div>
  );
}

export default TeamPage;
